<template>
  <div>
    <div v-if="showAdd == false" class="man-address">
      <a @click="close">
        <svg class="close-btn"><use xlink:href="#close"/></svg>
      </a>
      <a class="bck" @click="back"><img src="@/assets/back.svg"/></a>
      <h1>Address List</h1></br>
      <a class="addAddress" @click="showAdd = true">add new address</a>
      <table>
        <tr class="t-head">
          <th>Default</th>
          <th>Recipient</th>
          <th>Phone</th>
          <th>Address</th>
          <th>Operation</th>
        </tr>
        <tr v-if="list.length == 0">
          <td colspan="5" style="fontStyle:italic">You don't have any address yet.</td>
        </tr>
        <tr class="t-data" :class="{active: data.status == 1}" v-for="data in list">
          <!-- <td><a @click="setDef(data.id)"><img src="@/assets/check.svg"/></a></td> -->
          <td><a @click="setDef(data.id)">
                <svg class="check-btn"><use xlink:href="#check"/></svg>
          </a></td>
          <td>{{data.name}}</td>
          <td>{{data.phone}}</td>
          <!-- <td>{{data.country + " " + data.province + " " + data.city + " " + data.area + " " + getAddress(data.address)}}</td> -->
          <td>{{getAddress(data)}}</td>
          <td><a @click="editAdd(data.id)">Modify</a>&nbsp;&nbsp;&nbsp;&nbsp;<a @click="delAdd(data.id)">Delete</a></td>
        </tr>
      </table>
    </div>
    <add-address :addId="addId" v-if="showAdd" @back="updated" @close="close"/>
    <!-- SVG -->
    <svg display="none">
      <symbol width="15px" height="15px" viewBox="0 0 41.756 41.756" id="close">
        <path d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
          c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
          C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
          c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"/>
      </symbol>
      <symbol height="20px" viewBox="0 0 512 512" width="20px" id="check">
        <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm129.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"/>
      </symbol>
    </svg>
    <!-- #### -->
  </div>
</template>

<script>
import {GetAddress, DefAddress, DelAddress} from '@/api/index.js'
import AddAddress from './AddAddress.vue'
export default {
  data(){
    return{
      list:null,
      showAdd: false,
      addId:null,
    }
  },
  props:{
    fromConf:{
      type:String,
      default:"0",
    }
  },
  components:{
    AddAddress,
  },
  methods:{
    getAddress(addr){
      let printAdd = addr.country + ' ' + addr.province + ' ' + addr.city + ' ' + addr.area + ' ' + addr.address;
      if(printAdd.length > 67){
        return printAdd.substring(0,67) + '..';
      } else{
        return printAdd;
      }
    },
    updated(){
      this.showAdd = false;
      this.initData();
    },
    delAdd(id){
      DelAddress({'id':id}).then(res => {
        window.confirm('delete this address?');
        this.initData();
      })
    },
    initData(){
      this.addId = null;
      GetAddress({}).then(res => {
        this.list = res.data
      })
    },
    back(){
      this.$emit('back');
    },
    close(){
      this.$emit('close');
    },
    setDef(id){
      DefAddress({'id':id}).then(res =>{
        this.initData();
        window.alert('default address changed!');
      })
    },
    editAdd(id){
      this.addId = id;
      this.showAdd = true;
    }
  },

  created(){
      this.initData();
  },
}
</script>

<style lang="css" scoped>
.man-address{
  width:742.8px;
  overflow: hidden;
  position: fixed;
  top:18%;
  background:#fff;
  left:50%;
  transform: translateX(-50%);
  text-align: left;
  padding:30px;
  border-radius: 10px;
  overflow: auto;
  height: 400px;
  z-index: 110;
  box-shadow: 0px 10px 15px rgba(0,0,0,0.22);
}
table{
  margin-top: 15px;
  width: 100%;
  border-spacing: 0;
}
.t-head th{
  padding: 5px 0 10px;
  /* background: red; */
  text-align: center;
  border-bottom: 2px solid #ddd;
}
td{
  padding:15px 0;
  text-align: center;
  font-size: 13px;
}
td:nth-child(4){
  /* background: red; */
  /* width: 15%; */
}
th:nth-child(1){
  width: 5%;
}
td:nth-child(3){
  width: 15%;
}
td:nth-child(2){
  width: 20%;
}
td:nth-child(5){
  width: 20%;
}
img{
  width: 20px;
}
.active{
  background:#C4CCCE;
  font-weight: bold;
}
a{
  font-weight: normal!important;
}
a:hover{
  cursor: pointer;
  color: #719192;
  text-decoration: underline;
}

.bck img{
  width: 20px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}
.bck:hover{
  cursor: pointer;
}

h1{
  display: inline-block;
  vertical-align: middle;
  color:#3C4245;
}
.addAddress {
  color: #719192;
  display: block;
  margin-top: 10px;
}
.close{
  float:right;
}
.close img{
  width: 15px;
}
.close-btn{
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0;
  top: 10px;
  margin:10px 30px 0 0;
  fill:#5F6769;
}
.close-btn:hover{
  fill:#719192;
}
.check-btn{
  width: 20px;
  height: 20px;
  fill:#5F6769;
}
.check-btn:hover{
  fill:#719192;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/Components/ManageAddress.vue